(() => {
if(window.__shoppingTools1618)return;
window.__shoppingTools1618=true;
const root=window.Shopify?.routes?.root||'/';
const panel=document.getElementById('1618-favorites');
const read=(key,fallback)=>{try{return JSON.parse(localStorage.getItem(key)||JSON.stringify(fallback))}catch{return fallback}};
const ids=()=>{const a=read('1618-favorites',[]);return Array.isArray(a)?a.map(String):[]};
const details=()=>read('1618-favorite-details',{});
const save=(list,map)=>{localStorage.setItem('1618-favorites',JSON.stringify(list));localStorage.setItem('1618-favorite-details',JSON.stringify(map));sync();};
const money=n=>new Intl.NumberFormat(document.documentElement.lang||'ja',{style:'currency',currency:window.Shopify?.currency?.active||'JPY'}).format(n/100);
function sync(){
 const list=ids(),map=details();
 document.querySelectorAll('[data-favorite]').forEach(b=>{
  b.setAttribute('aria-pressed',String(list.includes(b.dataset.favorite)));
  if(list.includes(b.dataset.favorite)&&b.dataset.favoriteHandle)map[b.dataset.favorite]={...(map[b.dataset.favorite]||{}),handle:b.dataset.favoriteHandle,title:b.dataset.favoriteTitle,image:b.dataset.favoriteImage};
 });
 try{localStorage.setItem('1618-favorite-details',JSON.stringify(map))}catch{}
 document.querySelectorAll('[data-favorites-count]').forEach(e=>e.textContent=list.length||'');
}
function themed(path){
 const u=new URL(path,location.origin);
 const preview=new URL(location.href).searchParams.get('preview_theme_id');
 if(preview)u.searchParams.set('preview_theme_id',preview);
 else if(window.Shopify?.designMode&&panel?.dataset.theme)u.searchParams.set('preview_theme_id',panel.dataset.theme);
 return u;
}
async function recover(list,map){
 const missing=new Set(list.filter(id=>!map[id]?.handle));if(!missing.size)return;
 let url=themed(root+'collections/all?view=favorites-index');
 while(url&&missing.size){
  const r=await fetch(url,{credentials:'same-origin'});if(!r.ok)throw new Error('Catalog unavailable');
  const d=new DOMParser().parseFromString(await r.text(),'text/html'),catalog=d.querySelector('[data-favorites-catalog]');
  if(!catalog)throw new Error('Catalog unavailable');
  catalog.querySelectorAll('[data-id]').forEach(e=>{if(missing.has(e.dataset.id)){map[e.dataset.id]={handle:e.dataset.handle,title:e.dataset.title,image:e.dataset.image,available:e.dataset.available==='true'};missing.delete(e.dataset.id)}});
  url=catalog.dataset.next?themed(catalog.dataset.next+'&view=favorites-index'):null;
 }
}
let renderVersion=0,favoritesFilter='all',favoritesLoading=false;
function filterFavorites(){
 if(!panel)return;
 const rows=[...panel.querySelectorAll('[data-favorite-state]')],counts={all:rows.length,stock:0,sold:0};
 rows.forEach(row=>{if(row.dataset.favoriteState in counts)counts[row.dataset.favoriteState]++;row.hidden=favoritesFilter!=='all'&&row.dataset.favoriteState!==favoritesFilter});
 panel.querySelectorAll('[data-filter-count]').forEach(el=>el.textContent=counts[el.dataset.filterCount]);
 panel.querySelectorAll('[data-favorites-filter]').forEach(b=>{b.setAttribute('aria-pressed',String(b.dataset.favoritesFilter===favoritesFilter));b.disabled=favoritesLoading});
 if(!favoritesLoading)panel.querySelector('[data-favorites-status]').textContent=counts.all===0?panel.dataset.empty:counts[favoritesFilter]===0?(favoritesFilter==='stock'?panel.dataset.filterStockEmpty:panel.dataset.filterSoldEmpty):'';
}
panel?.querySelectorAll('[data-favorites-filter]').forEach(b=>b.addEventListener('click',()=>{favoritesFilter=b.dataset.favoritesFilter;filterFavorites()}));
async function renderFavorites(){
 if(!panel)return;const version=++renderVersion,list=ids(),map=details(),container=panel.querySelector('[data-favorites-list]'),status=panel.querySelector('[data-favorites-status]');
 favoritesLoading=true;container.replaceChildren();filterFavorites();status.textContent=list.length?'在庫を確認しています…':panel.dataset.empty;
 try{await recover(list,map)}catch{status.textContent=panel.dataset.failed}
 const results=await Promise.all(list.map(async id=>{
  const saved=map[id]||{},entry={id,...saved};
  if(!entry.handle)return {...entry,unresolved:true};
  try{
   const response=await fetch(root+'products/'+encodeURIComponent(entry.handle)+'.js',{cache:'no-store',credentials:'same-origin'});
   if(response.status===404)return {...entry,unavailable:true};
   if(!response.ok)throw new Error('Unavailable');
   const p=await response.json();return {...entry,title:p.title,image:p.featured_image,price:p.price,available:p.available,newlySold:saved.available===true&&!p.available};
  }catch{return {...entry,failed:true}}
 }));
 if(version!==renderVersion)return;
 status.textContent=list.length?'':panel.dataset.empty;
 for(const entry of results){
  if(!ids().includes(entry.id))continue;
  const row=document.createElement('article');row.className='favorite-list-item';row.dataset.favoriteState=entry.failed||entry.unavailable||entry.unresolved?'unknown':entry.available?'stock':'sold';
  const link=document.createElement('a');link.href=entry.handle?root+'products/'+encodeURIComponent(entry.handle):root+'collections/all';
  const img=document.createElement('img');img.alt=entry.title||'';img.loading='lazy';if(entry.image)img.src=entry.image;link.append(img);
  const info=document.createElement('div'),title=document.createElement('a');title.href=link.href;title.textContent=entry.title||'保存した商品';info.append(title);
  if(entry.price!=null){const price=document.createElement('p');price.textContent=money(entry.price);info.append(price)}
  const note=document.createElement('p');
  note.textContent=entry.failed?panel.dataset.failed:entry.unavailable||entry.unresolved?panel.dataset.unavailable:entry.available?panel.dataset.stock:panel.dataset.sold;
  if(entry.available===false||entry.unavailable)note.className='favorite-stock-alert';
  info.append(note);
  const remove=document.createElement('button');remove.type='button';remove.textContent=panel.dataset.remove;
  remove.addEventListener('click',()=>{const m=details();delete m[entry.id];save(ids().filter(id=>id!==entry.id),m);renderFavorites()});info.append(remove);row.append(link,info);container.append(row);
  if(!entry.failed&&!entry.unresolved)map[entry.id]={handle:entry.handle,title:entry.title,image:entry.image,available:entry.available};
 }
 favoritesLoading=false;filterFavorites();
 try{localStorage.setItem('1618-favorite-details',JSON.stringify(map))}catch{}
}
document.addEventListener('click',e=>{
 const favorite=e.target.closest('[data-favorite]');
 if(favorite){e.preventDefault();const list=ids(),map=details(),id=favorite.dataset.favorite;
  if(list.includes(id)){delete map[id];save(list.filter(x=>x!==id),map)}
  else{map[id]={handle:favorite.dataset.favoriteHandle,title:favorite.dataset.favoriteTitle,image:favorite.dataset.favoriteImage,available:favorite.dataset.favoriteAvailable==='true'};save([...list,id],map)}
 }
 if(e.target.closest('[data-open-favorites]')){favoritesFilter='all';panel?.showModal();renderFavorites()}
 if(e.target.closest('[data-close-favorites]'))panel?.close();
});
window.addEventListener('storage',()=>{sync();if(panel?.open)renderFavorites()});
window.addEventListener('pageshow',sync);
document.addEventListener('shopify:section:load',sync);
sync();
class StylePurchase extends HTMLElement{
 connectedCallback(){
  if(this.initialized)return;this.initialized=true;
  const form=this.querySelector('form'),button=form.querySelector('button'),status=form.querySelector('[role=status]');
  form.addEventListener('submit',async e=>{
   e.preventDefault();if(!form.reportValidity())return;
   button.disabled=true;status.textContent='';
   try{
    const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},credentials:'same-origin',body:JSON.stringify({items:[{id:form.elements.id.value,quantity:1}]})});
    const data=await response.json();if(!response.ok)throw new Error(data.description||'カートに追加できませんでした。');
    status.textContent='カートに追加しました。';form.querySelector('.ss-cart-link').hidden=false;
    document.dispatchEvent(new CustomEvent('1618:cart-change'));
    const cart=await fetch(root+'cart.js',{cache:'no-store'}).then(r=>r.json());
    document.querySelectorAll('#cart-icon-bubble .cart-count-bubble span[aria-hidden=true],.ed-tools [data-cart-count]').forEach(n=>n.textContent=cart.item_count);
   }catch(error){status.textContent=error.message}
   finally{button.disabled=false}
  });
 }
}
class FreeShippingNote extends HTMLElement{
 connectedCallback(){
  if(this.initialized)return;this.initialized=true;
  this.variants=JSON.parse(this.querySelector('script').textContent);this.total=Number(this.dataset.cart)||0;
  this.update=()=>{
   const form=document.getElementById(this.dataset.form),id=form?.querySelector('[name=id]')?.value;
   const variant=this.variants.find(v=>String(v.id)===id),quantity=Number(document.querySelector('[name=quantity][form="'+this.dataset.form+'"]')?.value||1);
   const remaining=1500000-this.total-(variant?.price??Number(this.dataset.price))*quantity;
   const progress=this.querySelector('[data-shipping-progress]');progress.hidden=!variant||!variant.available;
   progress.textContent=remaining>0?'国内送料無料まであと'+money(remaining):'この商品を追加すると国内送料無料の条件を満たします。';
  };
  this.onChange=()=>setTimeout(this.update,350);
  this.onInput=e=>{if(e.target.name==='quantity'&&e.target.getAttribute('form')===this.dataset.form)this.update()};
  this.refresh=async()=>{try{const cart=await fetch(root+'cart.js',{cache:'no-store'}).then(r=>r.json());this.total=cart.total_price;this.update()}catch{}};
  document.addEventListener('change',this.onChange);document.addEventListener('input',this.onInput);document.addEventListener('1618:cart-change',this.refresh);this.update();
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')this.unsubscribe=subscribe(PUB_SUB_EVENTS.variantChange,this.onChange);
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')this.unsubscribeCart=subscribe(PUB_SUB_EVENTS.cartUpdate,this.refresh);
 }
 disconnectedCallback(){document.removeEventListener('change',this.onChange);document.removeEventListener('input',this.onInput);document.removeEventListener('1618:cart-change',this.refresh);this.unsubscribe?.();this.unsubscribeCart?.();this.initialized=false}
}
customElements.define('style-purchase',StylePurchase);
customElements.define('free-shipping-note',FreeShippingNote);
})();
